module.exports = __webpack_public_path__ + "static/img/application6-1.8e9eb1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/application6-1.jpg
// module id = sbHq
// module chunks = 0